import React, { useState } from 'react';
import { useStyles } from '../../style';
import { Box, Grid, TextField, Typography } from '@mui/material';

import KenButton from '../../../../GlobalComponents/KenButton';
import { borderRadius } from '@mui/system';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid white',
  boxShadow: 24,
  borderRadius: 2,
  width: { lg: '35vw', xl: '35vw' },
  p: 2,
  overflowY: 'auto',
};
const AddSkill = (props: any) => {
  console.log('props', props);

  const classes = useStyles();

  return (
    <div>
      <Box sx={style}>
        <Typography sx={{ textAlign: 'left', fontWeight: 550, fontSize: '13px' }}>{props.data == 'edit' ? 'Edit Skills' : 'Add Skills'}</Typography>
        <hr style={{ border: '1px solid #E6E6E8' }} />
        <Grid container spacing={2} sx={{ marginTop: '-40px' }}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography sx={{ fontWeight: 500, mt: 2, fontSize: '12px' }}>Skills</Typography>
            <TextField
              sx={{
                mt: 1.5,
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-input': {
                  fontSize: '12px',
                },
              }}
              size="small"
              id="outlined-basic"
              placeholder="Skills (ex.project management)"
              variant="outlined"
              fullWidth
            />
          </Grid>
        </Grid>

        <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
          <KenButton
            variant="text"
            className={classes.button}
            sx={{
              mt: 1,
              borderRadius: '8px',
              width: 100,
              '&:hover': {
                backgroundColor: 'transparent',
              },
              '&:active': {
                backgroundColor: 'transparent',
              },
              '&:focus': {
                backgroundColor: 'transparent', // Ensures no background on focus
              },
              '&:focus-visible': {
                backgroundColor: 'transparent', // Ensures no background on keyboard focus
              },
              color: 'black',
            }}
            onClick={props.handleClose}
            fullWidth
          >
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#373A45' }}>Cancel</Typography>
          </KenButton>
          <KenButton
            variant="contained"
            className={classes.button}
            style={{ marginTop: 15, borderRadius: '8px', width: 100, marginLeft: 10, height: '36px', boxShadow: 'none' }}
            onClick={props.handleClose}
            fullWidth
          >
            <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Save</Typography>
          </KenButton>
        </Box>
      </Box>
    </div>
  );
};

export default AddSkill;
